export namespace ScreeningConstants {
  export const SCREENING_REASON_PRE_SERVICE: string = 'PRESVC';
  export const SCREENING_REASON_CONTINUOUS: string = 'CONT';
  export const SCREENING_REASON_RESCREEN: string = 'RESCRN';
  export const SCREENING_REASON_RANDOM: string = 'RAND';
  export const SCREENING_REASON_POST_INCIDENT: string = 'POSTINC';
  export const SCREENING_REASON_REASONABLE_SUSPICION: string = 'REASSUSP';
}
